/**
 * @constructor
 */
export default function LightboxPopup($link) {

    /**
     * Vars
     */
    let POPUP_SELECTOR = '.js-modal',
        $popup = $($link.attr('href')),
        $body = $('body'),
        isOpened = false,
        bodyClassPopupIsOpened = 'popup-is-opened';

    /**
     * Events
     */
    $link.on('click', show);

    $popup.find('.js-popup-close').on('click', close);

    $body.on('keyup', function (e) {
        if (e.keyCode === 27 && isOpened === true) {
            close();
        }
    });

    /**
     * Show popup
     */
    function show() {
        // если есть уже открытый попап - то закрыть
        $(POPUP_SELECTOR).filter(':visible').hide();

        $popup.show();
        $body.addClass(bodyClassPopupIsOpened);

        // запретить скролл когда открыт попап
        if (window.fullpage_api) {
            window.fullpage_api.setAllowScrolling(false)
        }

        isOpened = true;
    }

    /**
     * Close popup
     */
    function close() {
        $popup.hide();
        $body.removeClass(bodyClassPopupIsOpened);

        if (window.fullpage_api) {
            window.fullpage_api.setAllowScrolling(true)
        }

        isOpened = false;
    }
};
